import React from "react";
import ReactDOM from "react-dom";

export default function renderReactComponentInDocument(
    component: React.FunctionComponent<any> | React.ComponentClass<any, any> | string,
    props: any,
    element: Element
): void {
    if (props) {
        ReactDOM.render(React.createElement(component, props), element);
    }
}
